import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
    //#region Inputs, Outputs, ViewChilds
    //#endregion Inputs, Outputs, ViewChilds

    //#region Public Variables
    //#endregion Public Variables

    //#region Private Variables
    //#endregion Private Variables

    //#region Properties
    //#endregion Properties

    //#region Constructor and Angular Life Cycle
    //#endregion Constructor and Angular Life Cycle

    //#region Event Handlers
    //#endregion Event Handlers

    //#region Public Methods
    //#endregion Public Methods

    //#region Private Methods
    //#endregion Private Methods
}
